import { useQuery } from '@tanstack/react-query'
import { postNamedQuery } from '../../../../service'
import { paginateItems } from '../rssUtils'

const fetchRSSFeed = async (url) => {
  try {
    const { data } = await postNamedQuery('abundanceEngine', 'fetch-rss-feed', { url })

    if (!data || !data.feed || !Array.isArray(data.items)) {
      throw new Error('Invalid response format from RSS feed service')
    }

    const items = data.items.map(item => ({
      ...item,
      pubDate: item.pubDate ? new Date(item.pubDate) : null
    }))

    return {
      feed: data.feed,
      items,
      total: data.total || items.length
    }
  } catch (error) {
    if (error.code === 400) {
      throw new Error(`Invalid RSS feed URL: ${error.message}`)
    }
    if (error.code === 404) {
      throw new Error('RSS feed not found or unreachable')
    }
    if (error.code === 504) {
      throw new Error('RSS feed request timed out')
    }
    if (error.code >= 500) {
      throw new Error('RSS feed service temporarily unavailable')
    }
    throw new Error(`Failed to fetch RSS feed: ${error.message}`)
  }
}

export const useRSSFeed = ({
  url,
  take,
  skip
} = {}) => {
  return useQuery({
    queryKey: ['rssFeed', url, take, skip],
    queryFn: async () => {
      if (!url) {
        throw new Error('RSS feed URL is required')
      }

      const parsed = await fetchRSSFeed(url)

      let items = parsed.items
      items = paginateItems(items, take, skip)

      return {
        feed: parsed.feed,
        items,
        total: parsed.total
      }
    },
    enabled: !!url,
    retry: 1
  })
}
